import React, { useCallback, useMemo, useState } from "react";
import { Img, SelectBox, Input, Heading, Text, Button } from "..";
import { CloseSVG } from "../../assets/images";
import { useNavigate } from "react-router";
import { statusPoolOptions } from "constant/options";
import * as XLSX from "xlsx";
import * as loader from "../Loading/loading";
import DetailsModal from "components/ModalDetail";

const TableRow = ({
	company,
	status,
	noBatch,
	reportingData,
	owner_name,
	pool_name,
	pool_value,
	fund_manager_name,
	update_maturity_data,
	roll_over_data,
	status_maturity_data
}) => {
	const navigate = useNavigate();
	const [isOpenDetail, setIsOpenDetail] = useState(false);
	const [modalData, setModalData] = useState(null);

	const handleToDetail = () => {
		navigate(`/detail-pool?id=${noBatch}`);
	};

	const _status = useMemo(() => {
		var splitStr = status.toLowerCase().replaceAll("_", " ").split(" ");
		for (var i = 0; i < splitStr.length; i++) {
			splitStr[i] =
				splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
		}
		return splitStr.join(" ");
	}, [status]);

	// const _amount = useMemo(() => {
	// 	const statusExclude = ['redeemed', 'expired'];
	// 	return reportingData
	// 		.map((r) => statusExclude.includes(r.reporting_data.reporting_status) ? 0 : r.reporting_data.financing_amount)
	// 		.reduce((acc, curr) => acc + curr, 0);
	// }, [reportingData]);

	const _handleDownload = async () => {
		loader.showLoader();
		try {
			const ws = XLSX.utils.json_to_sheet(
				reportingData
					.filter((r) => r.reporting_data.reporting_status === "active")
					.map((r) => ({
						"Serial No": r.reporting_data.serial_no,
						"SAG No / Financing Ref No": r.reporting_data.financing_no,
						"Disbursement Date": r.reporting_data.disbursement_date.split("T")[0],
						"Maturity Date": r.reporting_data.maturity_date.split("T")[0],
						"Marhun Value (RM)": r.reporting_data.marhun_amount,
						"Financing Amount (RM)": r.reporting_data.financing_amount,
						"Outstanding Balance (RM)": r.reporting_data.outstanding_balance,
						"Profit Amount (RM)": r.reporting_data.profit_amount,
						"Margin of Financing (%)": r.reporting_data.margin_of_financing,
						"Profit Rate per annum (%)": r.reporting_data.profit_rate_per_annum,
						"Financing Tenure (months)": r.reporting_data.financing_tenure_months,
						"Remaining Tenure (months) as at cut-off date": r.reporting_data.remaining_tenure_months,
						"Surat Akuan Gadaian NO": r.reporting_data.mortgage_id,
						"Marhun Descriptions": r.reporting_data.marhun_description,
						"Status": r.reporting_data.reporting_status,
					}))
			);
			const wb = XLSX.utils.book_new();
			XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
			const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
			const blob = new Blob([excelBuffer], {
				type: "application/octet-stream",
			});
			const url = URL.createObjectURL(blob);

			const anchor = document.createElement("a");
			anchor.href = url;
			anchor.download = `POOL_DATA_${noBatch}.xlsx`;
			anchor.click();

			setTimeout(() => {
				URL.revokeObjectURL(url);
			}, 100);
		} catch (error) {
			console.error("Error downloading Excel:", error);
		} finally {
			loader.hideLoader();
		}
	};

	return (
		<div className="flex items-center w-full hover:bg-gray-50_02">
			{/* <CheckBox className="w-[7%]" value={checkbox} /> */}
			<Text
				as="p"
				className="!text-blue_gray-900_06 tracking-[-0.14px] w-[20%]"
			>
				{noBatch}
			</Text>
			<Text
				as="p"
				className="!text-blue_gray-900_06 tracking-[-0.14px] w-[20%] col-span-2"
			>
				{pool_name}
			</Text>
			<Text
				as="p"
				className="!text-blue_gray-900_06 tracking-[-0.14px] w-[18%] col-span-2"
			>
				{owner_name}
			</Text>
			<Text
				as="p"
				className="!text-blue_gray-900_06 tracking-[-0.14px] w-[18%] col-span-2"
			>
				{status === 'new' ? '-' : fund_manager_name}
			</Text>
			{/* <Text
        as="p"
        className="!text-blue_gray-900_06 tracking-[-0.14px] w-[15%] col-span-2"
      >
        {company}
      </Text> */}
			<Text
				as="p"
				className="!text-blue_gray-900_06 tracking-[-0.14px] w-[10%] col-span-2"
			>
				{pool_value}
			</Text>
			<Text
				as="p"
				className={`!font-semibold !text-blue_gray-900_06 tracking-[-0.14px] w-[10%] ${_status === "Active"
					? "!text-teal-700"
					: _status === "New"
						? "!text-blue_gray-600"
						: "!text-yellow-800_01"
					}`}
			>
				{_status}
			</Text>
			<div className="flex justify-center items-center w-[10%]">
				<div className="relative">
					<Img
						onClick={handleToDetail}
						src="images/img_carbon_view.svg"
						alt="materialsymbol"
						className="h-[24px] w-[24px] ml-2.5 mr-1 my-[17px]"
					/>
					{(update_maturity_data && 'active_until' in update_maturity_data && update_maturity_data?.status === 'pending') ||
						(roll_over_data && 'status' in roll_over_data && roll_over_data?.status?.includes('pending')) || 
						(status_maturity_data === 'pending') ?
						< div className="absolute top-3.5 right-0 bg-red-500 w-2 h-2 rounded-2xl" />
						: null
					}
				</div>
				<Img
					onClick={_handleDownload}
					src="images/img_material_symbol_black_900.svg"
					alt="Download Data"
					className="h-[18px] w-[18px] ml-2.5 my-[17px]"
				/>
			</div>
			<DetailsModal
				isOpen={isOpenDetail}
				title="Detail Pool"
				onButtonClick={() => setIsOpenDetail(false)}
				id={noBatch}
				totalLoan={modalData ? modalData.totalLoan : 0}
				marhunValue={modalData ? modalData.marhunValue : 0}
				outstandingBalance={modalData ? modalData.outstandingBalance : 0}
				financingAmt={modalData ? modalData.financingAmt : 0}
				ProfitAmt={modalData ? modalData.profitAmt : 0}
			/>
		</div>
	);
};

const TablePool = ({ data }) => {
	const [currentPage, setCurrentPage] = useState(1);
	const [itemsPerPage] = useState(50);
	const [searchTerm, setSearchTerm] = useState("");
	const [selectedStatus, setSelectedStatus] = useState("");
	const handleSearch = (e) => {
		setSearchTerm(e);
		setCurrentPage(1);
	};

	const [checkedItems, setCheckedItems] = useState(
		Array.isArray(data) ? Array(data.length).fill(false) : []
	);
	const [selectAll, setSelectAll] = useState(false);
	const handleItemClick = (index) => {
		const newCheckedItems = [...checkedItems];
		newCheckedItems[index] = !newCheckedItems[index];
		setCheckedItems(newCheckedItems);
	};

	// Pagination
	const indexOfLastItem = currentPage * itemsPerPage;
	const indexOfFirstItem = indexOfLastItem - itemsPerPage;
	const filteredData = data
		? data.filter(
			(item) =>
				(item.id.toLowerCase().includes(searchTerm.toLowerCase()) ||
					item.company.name
						.toLowerCase()
						.includes(searchTerm.toLowerCase())) &&
				(!selectedStatus || item.status === selectedStatus.value)
		)
		: [];
	const sortedData = filteredData.slice().sort((a, b) => {
		return new Date(b.created_at) - new Date(a.created_at);
	});

	const currentItems = sortedData.slice(indexOfFirstItem, indexOfLastItem);

	const paginate = (pageNumber) => setCurrentPage(pageNumber);

	const _downloadData = useCallback(() => {
		loader.showLoader();
		try {
			const statusExclude = ['redeemed', 'expired'];
			const ws = XLSX.utils.json_to_sheet(
				currentItems.map((item) => ({
					"Pool No": item.id,
					"Originator": item.owner_name,
					"Pool Name": item.pool_name,
					"Amount": item.pool_value,
					// "Amount": item.pooling_data
					//   .map((r) => statusExclude.includes(r.reporting_data.reporting_status) ? 0 : r.reporting_data.financing_amount)
					//   .reduce((acc, curr) => acc + curr, 0),
					Status: item.status === "non-active" ? "expired" : item.status,
				}))
			);
			const wb = XLSX.utils.book_new();
			XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
			const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
			const blob = new Blob([excelBuffer], {
				type: "application/octet-stream",
			});
			const url = URL.createObjectURL(blob);

			const anchor = document.createElement("a");
			anchor.href = url;
			anchor.download = `POOL_DATA.xlsx`;
			anchor.click();

			setTimeout(() => {
				URL.revokeObjectURL(url);
			}, 100);
		} catch (error) {
			console.error("Error downloading Excel:", error);
		} finally {
			loader.hideLoader();
		}
	}, []);

	return (
		<div className="flex flex-col items-center justify-start w-full gap-5">
			<div className="flex flex-row justify-between items-center w-full">
				<div className="flex flex-row justify-start items-center gap-[19px]">
					<Heading
						size="xl"
						as="h1"
						className="!text-gray-700 text-center !font-bold"
					>
						Filter Status :
					</Heading>
					<SelectBox
						indicator={
							<Img
								src="images/img_arrowdown_blue_gray_900_02.svg"
								alt="arrow_down"
							/>
						}
						name="status"
						placeholder="Status"
						options={statusPoolOptions}
						onChange={(value) => setSelectedStatus(value)}
						className="w-[14rem] gap-px !text-blue_gray-100_02 font-bold border-gray-300 border-2 border-solid !rounded-[5px]"
					/>
				</div>

				<div className="flex flex-row justify-start items-center gap-[15px]">
					<Input
						name="search"
						placeholder="Search Name"
						onChange={handleSearch}
						suffix={
							searchTerm?.length > 0 ? (
								<CloseSVG
									onClick={() => setSearchTerm("")}
									height={27}
									width={31}
									fillColor="#7e7e7eff"
								/>
							) : (
								<Img
									src="images/img_search.svg"
									alt="search"
									className="cursor-pointer"
								/>
							)
						}
						className="w-[267px] gap-[35px] text-gray-700 border-gray-300 border-2 border-dashed"
					/>
					{/* <Button color="yellow_800" size="sm" className="font-bold min-w-[126px]">
						Filter
					</Button> */}
					<Button color="yellow_800" size="sm" className="font-bold min-w-[100px]" onClick={_downloadData}>
						Download Data
					</Button>
				</div>
			</div>

			<div className="w-full bg-white-A700 shadow-2xl rounded-[10px] p-5 flex flex-col gap-10">
				{/* Table */}
				<div className="flex flex-col  w-full ">
					<div className="flex items-center w-full pb-5">
						{/* <CheckBox
              className="w-[7%]"
              onChange={handleSelectAll}
              value={selectAll}
            /> */}
						<Text
							as="p"
							className="!font-bold !text-blue_gray-200 tracking-[-0.14px] w-[20%]"
						>
							Pool No
						</Text>
						<Text
							as="p"
							className="!font-bold !text-blue_gray-200 tracking-[-0.14px] w-[20%]"
						>
							Pool Name
						</Text>
						<Text
							as="p"
							className="!font-bold !text-blue_gray-200 tracking-[-0.14px] w-[18%]"
						>
							Originator
						</Text>
						<Text
							as="p"
							className="!font-bold !text-blue_gray-200 tracking-[-0.14px] w-[18%]"
						>
							Fund Manager
						</Text>
						{/* <Text
              as="p"
              className="!font-bold !text-blue_gray-200 tracking-[-0.14px] w-[15%] col-span-2"
            >
              Issuer
            </Text> */}
						<Text
							as="p"
							className="!font-bold !text-blue_gray-200 tracking-[-0.14px] w-[10%] col-span-2"
						>
							Amount
						</Text>
						<Text
							as="p"
							className="!font-bold !text-blue_gray-200 tracking-[-0.14px] w-[10%]"
						>
							Status
						</Text>
						<Text
							as="p"
							className="!font-bold !text-blue_gray-200 tracking-[-0.14px] text-center w-[10%]"
						>
							Action
						</Text>
					</div>
					<div className="h-px bg-orange-100 w-full"></div>
					<div className="flex flex-col items-center justify-start w-full">
						{currentItems.map((item, index) => (
							<div
								key={index}
								className="w-full"
								onClick={() => handleItemClick(index)}
							>
								<TableRow
									{...item}
									noBatch={item.id}
									checkbox={checkedItems[index]}
									company={item.company.name}
									status={
										item.status === "non-active" ? "expired" : item.status
									}
									dateStart={item.created_at}
									submitDate={item.submit_date}
									activeDate={item.active_date}
									activeUntil={item.active_until}
									reportingData={item.pooling_data}
								/>
								<div className="h-px bg-orange-100 w-full"></div>
							</div>
						))}
					</div>
				</div>

				{/* Pagination */}
				<div className="flex flex-row justify-end items-center w-full">
					<div className="flex gap-3">
						<div
							onClick={
								currentPage > 1 ? () => paginate(currentPage - 1) : undefined
							}
							className="bg-gray-100_01 rounded-md font-medium border-gray-200 border border-solid h-6 w-6 flex justify-center items-center text-xs"
						>
							{`<`}
						</div>
						{Array.from(
							{ length: Math.ceil(filteredData.length / itemsPerPage) },
							(_, i) => (
								<div
									key={i}
									onClick={() => paginate(i + 1)}
									className={`rounded-md font-medium border-gray-200 border border-solid h-6 w-6 flex justify-center items-center text-xs ${currentPage === i + 1
										? "bg-yellow-800 text-white-A700"
										: "bg-gray-100_01 text-black-900"
										} `}
								>
									{i + 1}
								</div>
							)
						)}
						<div
							onClick={
								currentPage < Math.ceil(filteredData.length / itemsPerPage)
									? () => paginate(currentPage + 1)
									: undefined
							}
							className="bg-gray-100_01 rounded-md font-medium border-gray-200 border border-solid h-6 w-6 flex justify-center items-center text-xs"
						>
							{">"}
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default TablePool;
